"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var navItem_1 = require("./navItem");
exports.NavigationList = styled_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin: 0;\n  padding: 0;\n  user-select: none;\n  justify-content: center;\n  align-items: center;\n  height: 70px;\n  list-style: none;\n"], ["\n  display: flex;\n  margin: 0;\n  padding: 0;\n  user-select: none;\n  justify-content: center;\n  align-items: center;\n  height: 70px;\n  list-style: none;\n"])));
exports.Navigation = function (_a) {
    var nav = _a.nav;
    return (react_1.default.createElement(exports.NavigationList, null, nav.map(function (r, i) { return (react_1.default.createElement(navItem_1.NavItem, { key: "nav-" + r.label + "-i", id: "nav-" + r.label + "-i", item: r })); })));
};
var templateObject_1;
